import * as types from '../../../../../../constants/ActionNameConstants';

export const changePasswordRequest = (payload) => ({
  type: types.CHANGE_PASSSWORD_REQUEST,
  payload,
});

export const changePasswordSuccess = (payload) => ({
  type: types.CHANGE_PASSSWORD_SUCCESS,
  payload,
});

export const changePasswordFailure = (error) => ({
  type: types.CHANGE_PASSSWORD_FAILED,
  error,
});
